import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

/** Autocomplete for selecting a field from available options. */
export default function FieldAutocomplete({ options, value, onChange, label, sx = {}, ...rest }) {
  const strValue = typeof value === 'string' ? value : '';
  return (
    <Autocomplete
      size="small"
      options={options}
      value={value || null}
      onChange={(_, v) => onChange(v || '')}
      inputValue={strValue}
      onInputChange={(_, v) => onChange(v)}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" />
      )}
      sx={{ minWidth: 0, ...sx }}
      {...rest}
    />
  );
}
